import styled from 'styled-components';

export const StyledIconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledBar = styled.div`
    width: 33.33%;
`;
